import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — tarifa versionada por manejo (admin-billing-tariffs.md). Vigencias
// medio-abiertas sin solape; cambiar tarifa = cerrar-e-insertar (POST). Permiso billing:*.

export function useTariffs(managementId) {
    return useQuery({
        queryKey: billingKeys.tariffs(managementId),
        queryFn:  ({ signal }) => api.get(billingPaths.tariffs(), { params: { management_id: managementId }, signal }).then(r => r.data),
        enabled:  !!managementId,
    });
}

export function useCreateTariff() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.tariffs(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useDeleteTariff() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(billingPaths.tariff(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
